var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSharedopsLogoPhones(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 136.16 96.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fcfbfc;}.cls-2{fill:#f9f8f9;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "sharedops-logo-phones") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M349.58,344.1L321.72,320c-1.67,1.45-1,3-1,4.42-0.1,21.15-.22,42.3-0.09,63.46,0,3.55-1,4.37-4.42,4.36q-49.22-.21-98.44,0c-3.61,0-4.36-1.06-4.32-4.46,0.12-11.37,0-11.35,11.39-11.34,25.65,0,51.3-.09,77,0.07,3.75,0,4.75-.94,4.7-4.7-0.21-17.1-.09-34.19-0.09-52.64l-28.85,25c0-6.18,0-11.26,0-16.34,0-1.61,1.14-2.32,2.12-3.17,10.42-9.08,20.91-18.08,31.25-27.26,2.08-1.85,3.34-1.71,5.35.06,10.23,9.05,20.57,18,30.92,26.88a5.84,5.84,0,0,1,2.44,5.07C349.45,333.8,349.58,338.29,349.58,344.1Z",
    transform: "translate(-213.48 -295.99)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M234.92,349.16c-6.94.06-13.21-1.42-17.45-7.6a11.69,11.69,0,0,1-2.25-6.5,4.06,4.06,0,0,1,2.76-4.3,4.14,4.14,0,0,1,5.25,1.66c1,1.53,1.55,3.31,2.46,4.88,3.35,5.77,12.88,6.6,17.22,1.53,3.05-3.57,1.89-8-3-9.94-4-1.55-8.26-2.4-12.37-3.66-4.58-1.41-8.68-3.6-10.61-8.32a12.57,12.57,0,0,1,6-16.19,24.83,24.83,0,0,1,22.59-.26,11.81,11.81,0,0,1,6.45,7.27c0.93,2.93.46,5.41-2.48,6.7s-4.58-.39-6-2.79c-3.76-6.19-7.41-7.76-13-5.9-2.48.83-4.68,2.08-4.9,5s2,4.51,4.42,5.32c3.77,1.25,7.68,2.11,11.49,3.27,10.06,3.07,14,8.17,13,16.62-0.9,7.3-7.9,12.73-17.06,13.21C236.59,349.2,235.75,349.16,234.92,349.16Z",
    transform: "translate(-213.48 -295.99)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSharedopsLogoPhones);
export default __webpack_public_path__ + "static/media/sharedops-logo-phones.05d7dd28d9e873107a5cc3f482ce3db1.svg";
export { ForwardRef as ReactComponent };